import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { HolderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/customers-service-lib/src/wrapper/outputs/shared/holder.model';
import { useTranslation } from 'react-i18next';

interface InformationCardProps {
  holder: HolderModel;
}

export const InformationCard = ({
  holder,
}: InformationCardProps): React.JSX.Element => {
  const { t } = useTranslation();
  return (
    <Card flex={1} gap={GapEnum.M}>
      <AccentTitle
        icon="info-circle"
        as={HeadingEnum.H2}
        text={t('$.customer-details.information.title')}
      />
      <Stack justifyContent="space-between">
        <Text bold>
          {t('delmonicos-shared-sdk.outputs-holder.company-name')}
        </Text>
        <Text>{holder.companyName}</Text>
      </Stack>
      <Stack justifyContent="space-between">
        <Text bold>{t('delmonicos-shared-sdk.outputs-holder.siret')}</Text>
        <Text>{holder.siret}</Text>
      </Stack>
      <Stack justifyContent="space-between">
        <Text bold>{t('delmonicos-shared-sdk.outputs-holder.vat-number')}</Text>
        <Text>{holder.vatNumber}</Text>
      </Stack>
      <Stack justifyContent="space-between">
        <Text bold>
          <Icon name="marker-pin-01" />
          {t('delmonicos-shared-sdk.outputs-holder.address')}
        </Text>
        <Text>
          {holder.address.address}, {holder.address.zipCode}{' '}
          {holder.address.city} - {holder.address.countryCode}
        </Text>
      </Stack>
    </Card>
  );
};
